export default __webpack_public_path__ + "static/media/kr.893263e7.svg";